<section>
  <app-header [profile]="profile"></app-header>

  <section fxLayout="row" fxLayoutAlign="start start">
    <app-menu *ngIf="profile && user"></app-menu>

    <div fxFlex>
      <router-outlet></router-outlet>
    </div>
  </section>

</section>
